import React, { Component } from 'react'
import { login, logout, resetPassword, getCurrentUser } from '../../../helpers/auth'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";

import appState from '../../../helpers/AppState'

function setErrorMsg(error) {
  return {
    loginMessage: error
  }
}

export default class Login extends Component {

  state = {
    loading: true,
    currentUserEmail: "",
    loginMessage: null,
    redirectToReferrer: false
  }

  componentWillMount(){
    console.log("componentWillMount Login");
    console.log(appState);

  }


  handleSubmit = (e) => {
    e.preventDefault()
    console.log("Login");
    var xthis = this;
    login(this.email.value, this.pw.value).then(function(result){
      //console.log(result)
      //xthis.setState({ redirectToReferrer: true });

      /*
      const { from } = xthis.props.location.state || { from: { pathname: "/" } };
      console.log("this.props.location.state "+xthis.props.location.state)
      console.log(xthis.props.location.state)
      console.log("from.pathname "+from.pathname);
      xthis.props.history.push(from.pathname)
      */

    }).catch((error) => {
          console.log(error);
          this.setState(setErrorMsg('Invalid username/password.'))
    })
  }
  resetPassword = () => {
    resetPassword(this.email.value)
      .then(() => this.setState(setErrorMsg(`Password reset email sent to ${this.email.value}.`)))
      .catch((error) => this.setState(setErrorMsg(`Email address not found.`)))
  }
  render () {
/*
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    const { redirectToReferrer } = this.state;

    console.log("this.props.location.state "+this.props.location.state)
    console.log(this.props.location.state)
    console.log("from.pathname "+from.pathname);

    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }
    */

    /*
    if (this.state.loading) {
      console.log('This happens 4th - when waiting for data.');
      return <h2>Loading...</h2>;
    }*/


    if(appState.isAuthenticated){
      return (
        <div className="">
          <h3>logged in</h3>
          <p>you are currently logged in as a user: <i><b> {appState.currentUserEmail} </b></i> </p>
          <a href="#"
            onClick={() => { logout() }}>
            <i className="fa fa-sign-out fa-fw" /> Logout</a>
        </div>
      )
    }


    return (
      <div className="col-sm-6 col-sm-offset-3">
        <h1> Login </h1>
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input className="form-control" ref={(email) => this.email = email} placeholder="Email"/>
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" className="form-control" placeholder="Password" ref={(pw) => this.pw = pw} />
          </div>
          {
            this.state.loginMessage &&
            <div className="alert alert-danger" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.loginMessage} <a href="#" onClick={this.resetPassword} className="alert-link">Forgot Password?</a>
            </div>
          }
          <button type="submit" className="btn btn-primary">Login</button>
        </form>
      </div>
    )


  }
}



// WEBPACK FOOTER //
// ./src/components/pages/LoginPage/LoginPage.js